import React from "react";

type Props = {
    className?  : string
    options     : Option[]
    disabled?   : boolean

    field       : any

    onDelete    : callback
    onClick     : callback

    children?   : any
}

export default function FieldMultiselect_FormValueNotEmpty(props: Props) {

    const classes = Classes("ui5-field-form-editable dropdown-form fl-wrap min-h-36", props.className, {
        "is-disabled": props.disabled
    })

    return (
        <React.Fragment>
            <div className  = {classes}
                 onClick    = {props.onClick}>

                {_.map(props.options, option => {
                    // return <FieldMultiselect_Pill className="m-r-10 m-t-4 m-b-4" key={option.value} option={option} onDelete={props.onDelete}/>
                    return <props.field.components.Pill key         = {option.value}
                                                        disabled    = {props.disabled}
                                                        className   = "m-r-10 m-t-4 m-b-4"
                                                        option      = {option}
                                                        onDelete    = {props.onDelete}/>
                })}

            </div>

            {props.children}

        </React.Fragment>
    );
}
